import React, { useEffect, useState } from "react";
import styles from "./LandingScreen.module.scss";
import Button from '@mui/material/Button';
import { useNavigate } from 'react-router-dom';

function Landingscreen() {
  const navigate = useNavigate();
  
  const onLogin = () => {
    window.location.replace('https://ecehsrh8mi.execute-api.eu-south-2.amazonaws.com/dev/login');
  }
  const [token, setToken] = useState(null)

  const onLinkClick = (e) => {
    navigate(e);
  }

  useEffect(() => {
    setToken(window.localStorage.getItem('token'))
  }, [])

  return (
    <div className={styles.main}>
      <div className={styles.wrap}>
        <div className={styles.textWrap}>
          <h2>LEXAI, TU ASISTENTE I.A. DE INVESTIGACIÓN.</h2>
          <h2>SUBE TUS DOCUMENTOS, CHATEA SOBRE ELLOS Y RECIBE RECOMENDACIONES BIBLIOGRÁFICAS.</h2>
          <h2>LEXAI LA EXACTITUD TEÓRICA.</h2>
          { !token 
            ? <Button variant="contained" onClick={() => onLogin()}>Login</Button>
            : <React.Fragment>
              <Button className={styles.buttonExtra} variant="contained" onClick={() => onLinkClick('/upload')}>Upload</Button>
              <Button variant="contained" onClick={() => onLinkClick('/chat')}>Chat</Button>
            </React.Fragment>
          }
          
        </div>
      </div>
    </div>
  );
}

export default Landingscreen;


 